import { Injectable } from '@angular/core';
import { EcgBaseService } from './base/ecg-base.service';
import { EcgChartState } from '../../models/estensasign.model';
import {
    AuthData,
    IEcgApproveRequest,
    ISissCloudUploadRequest,
    ISissWayCloudUploadRequest,
    SissUploadDocumentData,
} from '@se/models';
import { SignType } from 'estensa-module';

@Injectable({
    providedIn: 'root',
})
export class EcgService extends EcgBaseService {
    constructor() {
        super();
    }

    getEcgTrace(examinationId: string, lowFilter?: number, highFilter?: number, reportId?: string) {
        const lowFilterParam = lowFilter != null ? `&lowFilter=${lowFilter}` : '';
        const highFilterParam = highFilter != null ? `&highFilter=${highFilter}` : '';
        const reportIdParam = reportId != null ? `&idClinicalReport=${reportId}` : '';
        const params = `?examinationId=${examinationId}${lowFilterParam}${highFilterParam}${reportIdParam}`;
        return this.getEcgBaseTrace(params);
    }

    approve(
        reportIds: string[],
        authData: AuthData | null = null,
        isDeferred = false,
        isFromWorklist?: boolean,
        displayedSettings?: EcgChartState,
        otherCredentialsData?: AuthData[],
        referringPhysicianId?: string,
    ) {
        let otherCredentials: string[] = [];
        if (otherCredentialsData && otherCredentialsData.length >= 1) {
            otherCredentialsData.forEach((credential) => {
                otherCredentials.push(this.encodeBase64(credential));
            });
        }

        const requestBody: IEcgApproveRequest = {
            reportIds,
            isDeferred,
            isFromWorklist,
            displayedSettings,
            otherCredentials,
            referringPhysicianId,
        };

        return this.approveBase(requestBody, authData);
    }

    uploadReportToSissCloud(data: SissUploadDocumentData) {
        const requestBody: ISissCloudUploadRequest = {
            type: SignType.SISSCloud,
            sissCloud: {
                reportIdList: data.reportIds,
                signerId: data.signerId,
                signerUsername: data.signerUsername,
                token: data.token,
            },
            isDeferred: data.isDeferred || false,
        };

        return this.uploadReportToSissCloudBase(requestBody);
    }

    uploadReportToSissWayCloud(data: SissUploadDocumentData) {
        const requestBody: ISissWayCloudUploadRequest = {
            type: SignType.SISSWayCloud,
            sissWayCloud: {
                reportIdList: data.reportIds,
                signerId: data.signerId,
                signerUsername: data.signerUsername,
                token: data.token,
                reportDocumentiList: data.reportDocumentiList,
                idStruttura: data.idStruttura,
                idSubStruttura: data.idSubStruttura,
                codBrancaSpecialistica: data.codBrancaSpecialistica,
            },
            isDeferred: data.isDeferred || false,
        };
        return this.uploadReportToSissWayCloudBase(requestBody);
    }
}
